import { ChipSelect } from './ChipSelect'

export default ChipSelect
